import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { InfoBar } from './components/InfoBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'pl';
    document.title = 'POLSKI GOTOWY™ – Gotowe lekcje polskiego dla klas 4–8';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3ihv0i9zd8dgr">
      <div lang="pl" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3ml1234bj9ggw">
        <InfoBar data-id="element-2" data-mp="3rcj2nr9n9f1c" />
        <main data-id="element-3" data-mp="3rbzpsoyupgu6">
          <Hero data-id="element-4" data-mp="3rdkh85pvcjnt" />
          <StatsBar data-id="element-5" data-mp="3rd19fhtxnbni" />
          <Difference data-id="element-6" data-mp="3relwynhtxubv" />
          <Recognize data-id="element-7" data-mp="6hr7hlrojf6" />
          <WhatsInside data-id="element-8" data-mp="4ww9qvjiygs" />
          <InsidePages data-id="element-9" data-mp="56n1goet9nj" />
          <Bonuses data-id="element-10" data-mp="7sxpp6lk59z" />
          <HowItWorks data-id="element-11" data-mp="2zllff2q1qmn9" />
          <Audience data-id="element-12" data-mp="2zm4xcjfp5b1a" />
          <Offer data-id="element-13" data-mp="2zmo89g6xiz5t" />
          <Guarantee data-id="element-14" data-mp="2zn678kkz7rhf" />
          <Faq data-id="element-15" data-mp="33mf2jtvnzxf3" />
          <FinalCta data-id="element-16" data-mp="33lwy49yumcw3" />
        </main>
        <Footer data-id="element-17" data-mp="33n6wl09m5n39" />
      </div>
    </MotionConfig>;
}